import React, { useEffect, useState } from "react";
import Navbar from "../common/Navbar";
import ContactUs from "../common/ContactUs";
import Footer from "../common/Footer";
import { Modal } from "antd";
//import LogoComponent from "../common/LogoComponent";

const AboutPage = () => {
  useEffect(() => {
    document.title = "About";
  }, []);

  const teamMembers = [
    {
      name: "Daniel",
      role: "Founder & CEO",
      title: "The Mind",
      image: "https://via.placeholder.com/150",
      bio: "Daniel is the visionary behind the company with years of leadership experience.",
    },
    {
      name: "Jaime",
      role: "Operations",
      title: "The Heart",
      image: "https://via.placeholder.com/150",
      bio: "Jaime manages day-to-day operations and ensures everything runs smoothly.",
    },
    {
      name: "Noah",
      role: "CTO",
      title: "The Engineer",
      image: "https://via.placeholder.com/150",
      bio: "Noah leads the engineering team, building innovative legal tech solutions.",
    },
    {
      name: "Kasper",
      role: "AI Legal Engine",
      title: "Our Machine",
      image: "https://via.placeholder.com/150",
      bio: "Kasper powers the AI-driven legal insights with unmatched efficiency.",
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  // const handleCardClick = (member) => {
  //   setSelectedMember(member);
  //   setShowModal(true);
  // };

  //const handleClose = () => setShowModal(false);

  return (
    <div
      className="bg-white text-dark"
      style={{ fontFamily: "Arial, sans-serif" }}
    >
      <Navbar />

      {/* Hero Section */}
      <section className="" style={{ padding: "150px 0px", width: "100%" }}>
        <div className="container text-center">
          <h1 className="display-3" id="main-font">
            A New Chapter in Justice
          </h1>
          <h1 className="display-5" id="main-font">
            Pro‑Slay isn’t just a platform. It’s a revolution.
          </h1>
          <p className="lead mt-4 mb-0 px-md-5">
            We are the first and only litigation firm in the country founded on
            the principle of an all-female team, with the singular purpose of
            challenging the gender imbalance and elitism that still dominate the
            American legal system.
          </p>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container text-center">
          <h1 className="mb-3 display-4" id="main-font">
            One Founder. Seven Women. Unlimited Justice.
          </h1>
          <p className="lead mb-0 px-md-5">
            Traditional law firms are built around power, hierarchy, and
            billable hours. The typical male partner earns $700,000+ a year and
            manages a handful of cases.
          </p>
          <p className="lead mb-0 px-md-5 mb-3">
            We’ve flipped the model entirely.
          </p>
          <p className="lead mb-0 px-md-5 text-start ms-5">
            <h3 className="display-5" id="main-font">
              At Pro‑Slay:
            </h3>
          </p>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="ms-5">
              Each $700,000 man is replaced by 7 women earning $100,000 each—a
              team of brilliant, focused professionals who each handle
              exponentially more cases with more precision, care, and speed.
            </li>
            <li className="ms-5">
              Every client is matched not just with cutting-edge AI (Kasper),
              but with a real woman—a case monitor, strategist, and advocate—who
              reviews, validates, and signs off on every filing.
            </li>
            <li className="ms-5">
              We reject frivolous, aggressive tactics and embrace what we call
              “holistic litigation.”
            </li>
          </ul>
        </div>
      </section>

      <section className="py-5 bg-white">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4" id="main-font">
            What Is Holistic Litigation?
          </h1>
          <p className="lead mb-0 px-md-5">
            <h3 className="display-5" id="main-font">
              Holistic litigation is built on:
            </h3>
          </p>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="ms-5">
              Human-AI collaboration: Our proprietary AI engine, Kasper, drafts
              court-admissible filings. But no document is ever submitted
              without human oversight.
            </li>
            <li className="ms-5">
              Court mindfulness: We believe in winning through merit, clarity,
              and honesty—not intimidation or procedural abuse.
            </li>
            <li className="ms-5">
              Client dignity: We serve real people, many of them representing
              themselves, and we treat them with the time, attention, and
              respect they deserve.
            </li>
          </ul>
        </div>
      </section>

      {/* <section className="py-5 bg-light">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4" id="main-font">
            Why All Women?
          </h1>
          <p className="lead mb-0 px-md-5">
            The law has long favored male voices, male power, and male-style
            tactics.
          </p>
          <p className="lead mb-0 px-md-5 mb-3">
            We’re not just here to level the playing field—we’re here to
            redesign it.
          </p>
          <p className="lead mb-0 px-md-5 text-start ms-5 mt-5 pt-3">
            <h3 className="display-5" id="main-font">
              By building a fully female-led company, we:
            </h3>
          </p>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="ms-5">
              Create a safe, bias-resistant environment for female legal
              professionals to thrive.
            </li>
            <li className="ms-5">
              Demonstrate the superiority of empathy + discipline over arrogance
              + aggression.
            </li>
            <li className="ms-5">
              Set a national example for how law can evolve in the age of AI and
              post-patriarchal thinking.
            </li>
          </ul>
        </div>
      </section> */}

      {/* <section className="py-5 bg-white"> */}
      <section className="py-5 bg-light">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4" id="main-font">
            One Man, Many Women, Infinite Justice
          </h1>
          <p className="lead mb-0 px-md-5">
            Pro‑Slay was founded by a single man, not to dominate the system—but
            to exit it and make space for something better.
          </p>
          <p className="lead mb-0 px-md-5">
            For two years, it will remain an all-female organization. It’s not a
            gimmick. It’s a blueprint.
          </p>
        </div>
      </section>

      {/* <section className="py-5 bg-light"> */}
      <section className="py-5 bg-white">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4" id="main-font">
            The Future Is Female. And Automated.
          </h1>
          <p className="lead mb-0 px-md-5">
            <h3 className="display-5" id="main-font">
              We are the only litigation company in America that combines:
            </h3>
          </p>
          <ul className="lead mb-0 px-md-5 text-start pt-3 mt-3">
            <li className="ms-5">A 100% female operational team</li>
            <li className="ms-5">An AI-powered litigation engine</li>
            <li className="ms-5">
              A subscription-based access model for pro se litigants
            </li>
            <li className="ms-5">
              A personal case monitor for every single client
            </li>
          </ul>
          <p className="lead mb-0 px-md-5 text-start ms-5">
            Together, that adds up to:
          </p>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="ms-5">20x the productivity</li>
            <li className="ms-5">1/10th the cost</li>
            <li className="ms-5">100x the fairness</li>
          </ul>
        </div>
      </section>

      {/* <section className="team-section-offset bg-white py-5 text-start"> */}
      <section className="team-section-offset bg-light py-5 text-start">
        <div className="container py-4">
          <div className="row">
            <div className="col-12 mb-4">
              <h1 className="-head display-4" id="main-font">
                The Team
              </h1>
            </div>
            {teamMembers.map((member, index) => (
              <div key={index} className="col-md-6 mb-4">
                <div
                  className="team-card p-4 rounded shadow h-100"
                  onClick={() => {
                    setSelectedMember(member);
                    setShowModal(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <h2 className="display-5" id="main-font">
                    {member.title}
                  </h2>
                  <p className="lead">
                    {member.name}, {member.role}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Modal */}
        <Modal
          title={`${selectedMember?.name} - ${selectedMember?.role}`}
          open={showModal}
          onCancel={() => setShowModal(false)}
          footer={null}
          centered
        >
          <div className="text-center">
            <img
              src="assets/img/userImg.jpg"
              alt={selectedMember?.name}
              className="rounded-circle mb-3"
              style={{
                width: "150px",
                height: "150px",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
            <h3 className="mb-2 display-4" id="main-font">
              {selectedMember?.title}
            </h3>
            <p>{selectedMember?.bio}</p>
          </div>
        </Modal>
      </section>

      {/* <section className="vision-section-offset bg-light py-5 text-start">
        <div className="container py-5">
          <h1 className=" display-4" id="main-font">Our Vision</h1>
          <p className="lead mb-0">A world where anyone can stand up to powerful interests and win.</p>
        </div>
      </section> */}

      <ContactUs />
      <Footer />
    </div>
  );
};

export default AboutPage;
